"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reducer = _interopRequireDefault(require("settings-ui-sdk/EspSync/reducer"));

var _LaboratoryReducer = _interopRequireDefault(require("settings-ui-sdk/Laboratory/LaboratoryReducer"));

var _default = (0, _redux.combineReducers)({
  espSync: _reducer.default,
  laboratory: _LaboratoryReducer.default
});

exports.default = _default;
module.exports = exports.default;